import { makeStyles, withStyles } from '@material-ui/core/styles'

import ContainerBox from 'artkive/components/PageSections/ContainerBox'

export const BoxGradient = withStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.up('md')]: {
      backgroundColor: '#E3F2FD',
    },
  },
}), {
  withTheme: true,
})(ContainerBox)

export const useStyles = makeStyles(({ breakpoints }) => ({
  root: {
    minHeight: 'calc(100vh - 64px)',
    backgroundColor: 'rgb(245, 249, 250)',
    display: 'flex',
    flexDirection: 'column',
  },
  container: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    '&$container': {
      padding: '60px',
      [breakpoints.down('sm')]: {
        marginTop: 50,
        padding: '0 80px',
      },
    },
  },
  description: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  productContainer: {
    marginBottom: 64,
  },
  productImage: {
    flexBasis: '100%',
    width: '100%',
    height: 0,
    maxWidth: '100%',
    [breakpoints.down('sm')]: {
      width: 210,
    },
  },
  header: {
    [breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  title: {
    fontSize: '2rem',
    [breakpoints.down('md')]: {
      fontSize: '1.75rem',
    },
    [breakpoints.down('sm')]: {
      fontSize: '1.5rem',
      marginTop: '1.5rem',
      padding: '0 42px',
    },
  },
  subtitle: {
    fontSize: '1.25rem',
    fontWeight: 500,
    lineHeight: 1.6,
    [breakpoints.down('sm')]: {
      fontSize: '1rem',
    },
  },
  topLines: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '15%',
    transform: 'translate(-70%, -100%)',
  },
  bottomLines: {
    position: 'absolute',
    right: 0,
    bottom: 0,
    height: '30%',
    transform: 'translate(30%, -10%)',
    [breakpoints.down('sm')]: {
      transform: 'translate(50%, -10%)',
    },
  },
}))
